import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "../api/apiClient";

const RECONNECT_DELAY_MS = 2000;
const HEARTBEAT_INTERVAL_MS = 30000;

const PortfolioRefreshListener = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/manage")) {
      return undefined;
    }

    let active = true;
    let socket;
    let reconnectTimer;
    let heartbeatTimer;

    const connect = () => {
      socket = new WebSocket(apiClient.getPortfolioUpdatesUrl());

      socket.onopen = () => {
        heartbeatTimer = window.setInterval(() => {
          if (socket.readyState === WebSocket.OPEN) {
            socket.send("ping");
          }
        }, HEARTBEAT_INTERVAL_MS);
      };

      socket.onmessage = (message) => {
        try {
          const event = JSON.parse(message.data);
          if (event.type === "portfolio.updated") {
            window.location.reload();
          }
        } catch {
          // Ignore messages that are not portfolio update events.
        }
      };

      socket.onclose = () => {
        window.clearInterval(heartbeatTimer);
        if (active) {
          reconnectTimer = window.setTimeout(connect, RECONNECT_DELAY_MS);
        }
      };
    };

    connect();

    return () => {
      active = false;
      window.clearTimeout(reconnectTimer);
      window.clearInterval(heartbeatTimer);
      if (socket && socket.readyState < WebSocket.CLOSING) {
        socket.close();
      }
    };
  }, [location.pathname]);

  return null;
};

export default PortfolioRefreshListener;
